import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import {
  InfantPackageDetails,
  CompletePackageDetails,
  CompleteAndMerit
} from "./InnerJSXForTB";

const PackageDescription = props => {
  const { description, visible, packageID } = props;
  const Description = ({ packageID, description }) => {
    if (packageID === 34) {
      return <InfantPackageDetails />;
    } else if (packageID === 4) {
      return <CompletePackageDetails />;
    } else if (packageID === 232) {
      return <CompleteAndMerit />;
    } else {
      return <ReactMarkdown>{description}</ReactMarkdown>;
    }
  };

  return (
    // if visible is true then return the description, else
    // return nothing
    visible && (
      <div className={`package__desc ${props.familyID === 15 ? "paper-package" : ""}`}>
        <Description description={description} packageID={packageID} />
      </div>
    )
  );
};

PackageDescription.propTypes = {
  description: PropTypes.string,
  visible: PropTypes.bool,
  packageID: PropTypes.number
};
export default PackageDescription;
